import QForm from './src/form';
export default QForm;
